import { jsx, Fragment } from "react/jsx-runtime";
import { useId, useEffect } from "react";
import { useOnAdd } from "./main12.mjs";
const useCreateRoot = ({
  children,
  frameloop,
  fromLngLat,
  ...renderProps
}) => {
  const id = useId();
  const { onAdd, onRemove, mounted, r3mRef } = useOnAdd(fromLngLat, { frameloop, ...renderProps });
  useEffect(() => {
    if (!mounted)
      return;
    if (!r3mRef.current.root)
      return;
    r3mRef.current.root.render(/* @__PURE__ */ jsx(Fragment, { children }));
  }, [r3mRef, mounted, children]);
  return { id, onAdd, onRemove, r3mRef };
};
export {
  useCreateRoot
};
//# sourceMappingURL=main10.mjs.map
